import config from './config'

export const FORM_LAYOUT = config
